import { EcommCalculationsInputData, LegacyInputType } from './types';
import { CalculationPriceService } from '../../constants/calculations';

// Inlined from '../utils' to avoid TypeScript declaration conflicts during gradual TS migration
// TODO: Remove this duplication once utils.js is properly converted to TypeScript
const removeTypename = (value: any): any => {
  if (value === null || value === undefined) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map((v) => removeTypename(v));
  }
  if (value instanceof Date) {
    return value;
  }
  if (typeof value === 'object') {
    const newObj: any = {};
    Object.entries(value).forEach(([key, v]) => {
      if (key !== '__typename') {
        newObj[key] = removeTypename(v);
      }
    });
    return newObj;
  }
  return value;
};

export const ecommCalculationsInput = (
  data: EcommCalculationsInputData,
  priceService: CalculationPriceService
): LegacyInputType => {
  const {
    appliedRewards,
    bypassCanadaDeliveryTax,
    cart,
    couponValue,
    deliveryOption,
    dispensary,
    firstTimePBBUser,
    manualDiscount,
    medicalOrder,
    paymentMethod,
    tipValue,
    toMenu,
  } = data;

  const legacyInput: LegacyInputType = {
    cart,
    deliveryOption,
    medicalOrder,
    couponValue,
    manualDiscount,
    tipValue,
    firstTimePBBUser,
    paymentMethod,
    toMenu,
    appliedRewards,
    bypassCanadaDeliveryTax,
    priceService,
    dispensary: {
      id: dispensary.id,
      taxConfig: dispensary.taxConfig,
      location: dispensary.location,
      storeSettings: dispensary.storeSettings,
      specialsSettings: dispensary.specialsSettings,
      mixAndMatchPricingWeights: dispensary.mixAndMatchPricingWeights,
      useDartDiscountsPath: dispensary.useDartDiscountsPath,
      timezone: dispensary.timezone,
      dispensaryTimezone: dispensary.dispensaryTimezone,
      feeTiers: dispensary.feeTiers,
      paymentFees: dispensary.paymentFees,
      deliveryInfo: dispensary.deliveryInfo,
    },
  };

  return removeTypename(legacyInput);
};
